import {
  Button,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { Container, ContainerForm, ContainerFormRight, Title } from "../../styles/index.sty";
import AlertSnack from "../../components/Alert/AlertSnack";
import { useAuth } from "../../context/authContext";
import { useLists } from "../../context/listContext";
import { insertProductConfigData, updateProductConfigData } from "../../api/products.api";
import { useEffect } from "react";

export const AddProductConfig = () => {
  const { config2 } = useAuth();
  const {
    finishList,
    fetchFinishesList,
    sizesList,
    fetchSizesList,
    storagesList,
    fetchStoragesList,
    colorsList,
    fetchColorsList,
    materialsList,
    fetchMaterialsList
  } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const prodConfInfo = location?.state?.data;
  const prodOgInfo = location?.state?.prodData;
  const [product_finish_id, setProduct_finish_id] = useState(
    prodConfInfo?.product_finish_id
  );
  const [product_size_id, setProduct_size_id] = useState(
    prodConfInfo?.product_size_id
  );
  // const [brand_id, setBrand_id] = useState(prodConfInfo?.brand_id);
  const [product_storage_id, setProduct_storage_id] = useState(
    prodConfInfo?.product_storage_id
  );

  const [ dimensions, setDimensions ] = useState({
    length: prodConfInfo?.dimensions.split(/[ LHW*]+/)[0] || prodOgInfo?.dimensions.split(/[ LHW*]+/)[0],
    width: prodConfInfo?.dimensions.split(/[ LHW*]+/)[1] || prodOgInfo?.dimensions.split(/[ LHW*]+/)[1],
    height: prodConfInfo?.dimensions.split(/[ LHW*]+/)[2] || prodOgInfo?.dimensions.split(/[ LHW*]+/)[2]
  });

  useEffect(() => {
    fetchFinishesList();
    fetchSizesList();
    fetchStoragesList();
    fetchColorsList();
    fetchMaterialsList();
  }, [])
  
  useEffect(() => {
    setProduct_finish_id(prodConfInfo?.product_finish_id);
    setProduct_size_id(prodConfInfo?.product_size_id);
    setProduct_storage_id(prodConfInfo?.product_storage_id);
    console.log("This is configuration data", prodConfInfo);
    console.log("This is original data", prodOgInfo);
  }, [prodConfInfo]);
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState({});
  const formik = useFormik({
    initialValues: {
      product_name: prodConfInfo?.product.product_name || prodOgInfo?.product_name,
      product_description: prodConfInfo?.product.product_description || prodOgInfo?.product_description,
      product_short_description: prodConfInfo?.product_short_description || prodOgInfo?.product_short_description,
      product_overview: prodConfInfo?.product_overview || prodOgInfo?.product_overview,
      product_price: prodConfInfo?.finish_price || prodOgInfo?.product_price,
      offer_price: prodConfInfo?.offer_price_price || prodOgInfo?.offer_price,
      finish_price: prodConfInfo?.finish_price || prodOgInfo?.finish_price,
      size_price: prodConfInfo?.size_price || prodOgInfo?.size_price,
      storage_price: prodConfInfo?.storage_price || prodOgInfo?.storage_price,
      material: prodConfInfo?.material || prodOgInfo?.material,
      color: prodConfInfo?.color || prodOgInfo?.color,
      product_offer_price: prodConfInfo?.product.product_offer_price || prodOgInfo?.product_offer_price,
      stock: prodConfInfo?.stock || prodOgInfo?.stock,
      product_warranty: prodConfInfo?.product_warranty || prodOgInfo?.product_warranty
    },
    onSubmit: async (values) => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateProductConfigData(
          {
            ...values,
            finish_price: values.product_price,
            size_price: values.product_price,
            storage_price: values.product_price,
            file,
            ...dimensions,
            product_config_id: prodConfInfo?.product_config_id,
            // brand_id,
            product_size_id,
            product_finish_id,
            product_storage_id,
          },
          config2
        );
        setResponse(submit);
        setOpen(true);
        if (submit.status === "success") {
          navigate("/product-configs", 
            // {
            //   state: {
            //     postSave: prodOgInfo
            //   }
            // }
          );
        }
      } else {
        const submit = await insertProductConfigData(
          {
            ...values,
            file,
            finish_price: values.product_price,
            size_price: values.product_price,
            storage_price: values.product_price,
            product_id: prodOgInfo.product_id,
            ...dimensions,
            // brand_id,
            product_size_id,
            product_finish_id,
            product_storage_id,
          },
          config2
        );
        setResponse(submit);
        setOpen(true);
        if (submit.status === "success") {
          navigate("/product-configs");
        }
      }
    },
  });

  return (
    <>
      <Container style={{margin: "1rem 0"}}>
        <Title variant="h5" className="w-[100%]">
          Enter Product Details.
        </Title>
        <ContainerForm>
          <div className="w-[100%]">
            {open && (
              <AlertSnack
                open={open}
                setOpen={setOpen}
                response={response}
                setLoading={setLoading}
                route="customers"
              />
            )}

            {loading ? (
              <div className="items-center">
                <BeatLoader color="#36d7b7" />
              </div>
            ) : (
              <div style={{ width: "80%", margin: "auto" }}>
                {/* <FormGroup>
                  <InputLabel id="demo-simple-select-label">Brand:</InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={brand_id}
                    style={{ textAlign: "left" }}
                    onChange={(e) => {
                      setBrand_id(e.target.value);
                    }}
                  >
                    {brandsList.map((cat) => {
                      return (
                        <MenuItem value={cat.brand_id}>
                          {cat.brand_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormGroup>
                <br /> */}
              <FormGroup>
                <InputLabel id="demo-simple-select-label">
                  Product Finish:
                </InputLabel>
                <Select
                  id="demo-simple-select"
                  value={product_finish_id}
                  style={{ textAlign: "left" }}
                  onChange={(e) => {
                    setProduct_finish_id(e.target.value);
                  }}
                >
                  {finishList.map((bar) => {
                    return (
                      <MenuItem
                        value={bar.product_finish_id}
                        key={bar.product_finish_id}
                      >
                        {bar.finish_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
                <FormGroup>
                  <InputLabel htmlFor="finish_price">
                    Finish Price:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="finish_price"
                    placeholder="Enter Finish Price"
                    id="finish_price"
                    type="number"
                    disabled
                    value={formik.values.product_price}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel id="demo-simple-select-label">
                    Product Size:
                  </InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={product_size_id}
                    style={{ textAlign: "left" }}
                    onChange={(e) => {
                      setProduct_size_id(e.target.value);
                    }}
                  >
                    {sizesList.map((cat) => {
                      return (
                        <MenuItem value={cat.product_size_id}>
                          {cat.size_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="size_price">
                    Size Price:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="size_price"
                    placeholder="Enter Size Price"
                    id="size_price"
                    type="number"
                    disabled
                    value={formik.values.product_price}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel id="demo-simple-select-label">
                    Product Storage:
                  </InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={product_storage_id}
                    style={{ textAlign: "left" }}
                    onChange={(e) => {
                      setProduct_storage_id(e.target.value);
                    }}
                  >
                    {storagesList.map((sub_cat) => {
                      return (
                        <MenuItem value={sub_cat.product_storage_id}>
                          {sub_cat.storage_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="storage_price">
                    Storage Price:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="storage_price"
                    placeholder="Enter Storage Price"
                    id="storage_price"
                    type="number"
                    disabled
                    value={formik.values.product_price}
                    // onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_name">Product Name: </InputLabel>
                  <OutlinedInput
                    disabled
                    name="product_name"
                    placeholder="Enter Product Name"
                    id="product_name"
                    type="text"
                    value={formik.values.product_name}
                    // value={formik.values.product_name}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_description">
                    Product Description:{" "}
                  </InputLabel>
                  <OutlinedInput
                    disabled
                    name="product_description"
                    placeholder="Enter Product Description"
                    id="product_description"
                    type="text"
                    value={formik.values.product_description}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_short_description">
                    Product Short Description:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="product_short_description"
                    placeholder="Enter Product Short Description"
                    id="product_short_description"
                    type="text"
                    multiline
                    value={formik.values.product_short_description}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_overview">
                    Product Overview:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="product_overview"
                    placeholder="Enter Product Overview"
                    id="product_overview"
                    type="text"
                    multiline
                    value={formik.values.product_overview}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup className="flex wrap w-1/1">
                  <InputLabel className="w-1/1" htmlFor="dimensions">
                    Product Dimensions:{" "}
                  </InputLabel>
                  <div className="flex">
                    <OutlinedInput
                      className="w-1/3"
                      name="width"
                      placeholder="Width"
                      id="width"
                      type="text"
                      value={dimensions.width}
                      onChange={(e) => setDimensions(prev => ({...prev, width: e.target.value}))}
                      />
                    <OutlinedInput
                      className="w-1/3"
                      name="length"
                      placeholder="Length"
                      id="length"
                      type="text"
                      value={dimensions.length}
                      onChange={(e) => setDimensions(prev => ({...prev, length: e.target.value}))}
                    />
                    <OutlinedInput
                      className="w-1/3"
                      name="height"
                      placeholder="Height"
                      id="height"
                      type="text"
                      value={dimensions.height}
                      onChange={(e) => setDimensions(prev => ({...prev, height:  e.target.value}))}
                      />
                  </div>
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="file">Product Image: </InputLabel>
                  <OutlinedInput
                    name="file"
                    placeholder="Select Image"
                    id="file"
                    type="file"
                    // value={file}
                    onChange={(e) => setFile(e.target.files[0])}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_price">
                    Product Price:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="product_price"
                    placeholder="Enter Product Price"
                    id="product_price"
                    type="number"
                    value={formik.values.product_price}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="offer_price">
                    Product Offer Price:{" "}
                  </InputLabel>
                  <OutlinedInput
                    name="offer_price"
                    placeholder="Enter Product Offer Price"
                    id="offer_price"
                    type="number"
                    value={formik.values.offer_price}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
              <FormGroup>
                <InputLabel id="demo-simple-select-label">
                  Color:
                </InputLabel>
                <Select
                  id="demo-simple-select"
                  value={formik.values.color}
                  style={{ textAlign: "left" }}
                  onChange={formik.handleChange}
                >
                  {colorsList.map((color) => {
                    return (
                      <MenuItem
                        value={color.color_name}
                        key={color.color_name}
                      >
                        {color.color_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel id="demo-simple-select-label">
                  Material:
                </InputLabel>
                <Select
                  id="demo-simple-select"
                  value={formik.values.material}
                  style={{ textAlign: "left" }}
                  onChange={formik.handleChange}
                >
                  {materialsList.map((material) => {
                    return (
                      <MenuItem
                        value={material.material_name}
                        key={material.material_name}
                      >
                        {material.material_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
                <FormGroup>
                  <InputLabel htmlFor="stock">Stock: </InputLabel>
                  <OutlinedInput
                    name="stock"
                    placeholder="Enter Stock"
                    id="stock"
                    type="number"
                    value={formik.values.stock}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <InputLabel htmlFor="product_warranty">Product Warranty: </InputLabel>
                  <OutlinedInput
                    name="product_warranty"
                    placeholder="Enter Product Warranty"
                    id="product_warranty"
                    type="number"
                    value={formik.values.product_warranty}
                    onChange={formik.handleChange}
                  />
                </FormGroup>
                <div className="flex flex-row justify-between">
                  <Button
                    type="button"
                    variant="contained"
                    color="info"
                    onClick={() => navigate("/product-configs")}
                    style={{
                      marginTop: "1rem",
                      width: "48%",
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    color="info"
                    onClick={formik.handleSubmit}
                    style={{
                      marginTop: "1rem",
                      width: "48%",
                    }}
                  >
                    Save & Continue
                  </Button>
                </div>
              </div>
            )}
          </div>
        </ContainerForm>
        <ContainerFormRight>
          <div className="flex flex-wrap">
            <p className="text-2xl mb-4 w-[100%]">
              <b>Image Preview</b>
            </p>
            <hr />
            {location?.pathname.includes("update") ? (
              <div className="w-[50%] mb-12">
                <p className="text-xl mb-4">
                  <b>Old Image</b>
                </p>
                <img
                  className=" m-auto"
                  src={prodConfInfo?.product_finish_image_file || prodOgInfo?.product_finish_image_file}
                  alt={prodConfInfo?.product_finish_image_name || prodOgInfo?.product_finish_image_name}
                />
              </div>
            ) : null}
            <div className="w-[50%]">
              <p className="text-xl mb-4">
                <b>New Image</b>
              </p>
              {file ? (
                <img
                  className=" m-auto"
                  src={URL.createObjectURL(file)}
                  alt={prodConfInfo?.product_finish_image_name || prodOgInfo?.product_finish_image_name}
                />
              ) : (
                <p>No Image Selected</p>
              )}
            </div>
          </div>
        </ContainerFormRight>
      </Container>
    </>
  );
};
